module.exports = __webpack_public_path__ + "img/nationwide-warranty.11811672.png";